<template>
  <div class="edu-help-line">
    <p class="line-faq"></p>
    <div class="line-customer" @click="handleCustomerService">
      <img src="@zhenguo/jssdk/assets/customer-service.svg" class="customer-icon" alt="客服" />
      <span class="customer-text">咨询客服</span>
    </div>
  </div>
</template>

<script setup>
import { lxMC } from '@zhenguo/jssdk/lx'
import { errorHandler } from '@zhenguo/jssdk/axios/response'
import { pushPage } from '@zhenguo/jssdk/router'
import Api from './api'

const handleCustomerService = async () => {
  lxMC('b_airbnb_d7rf6zxs_mc')
  try {
    const url = await Api.getCSCUrl()
    url && pushPage(url)
  } catch (error) {
    errorHandler(error)
  }
}
</script>

<style scoped lang="less">
.edu-help-line {
  display: flex;
  font-size: 12px;
  margin-top: 20px;
  align-items: flex-end;
  justify-content: space-between;

  .line-faq {
    color: #7d7e80;
    height: 17px;

    .faq-link {
      color: #3c64b4;
      text-decoration: none;
    }
  }

  .line-customer {
    display: flex;
    height: 20px;
    align-items: flex-end;

    .customer-icon {
      height: 20px;
      width: 20px;
      margin-right: 2px;
    }

    .customer-text {
      height: 17px;
    }
  }
}
</style>
